export const DATE_FORMAT = 'DD MMM, YYYY';
export const DATE_MONTH_FORMAT = 'MMM, YYYY';
export const DATE_TIME_FORMAT = 'DD MMM, YYYY h:mm a'
export const DATE_FORMAT_SERVER = 'YYYY-MM-DD';
export const DATE_FORMAT_INPUT = 'DD-MM-YYYY';
export const DATE_MONTH_INPUT = 'MM/YYYY';